<template>
    <div :class="['header-box',['Home','culturalTour'].includes(routeName) ? '' : 'header-bg-white']">
        <div class="header-logo">
            <img v-if="['Home','culturalTour'].includes(routeName)"
                 class="logo"
                 src="@/assets/imgs/logo111.png"
                 alt="logo">
            <img v-else
                 class="logo"
                 src="@/assets/imgs/mmexport1756284142806.png"
                 alt="logo">
            <span class="font-style-s">{{ dateTime }}  </span>
        </div>
        <div class="container mean-box">
            <div :class="['mean',routeName == item.routeName ? 'mean-active' : '']"
                 v-for="(item,i) in lists"
                 :key="i"
                 @click="handleClick(item)">
                <span class="font-style-s">{{ item.name }}</span>
                <span v-if="item.tag" class="tag">{{ item.tag }}</span>
            </div>
            <img v-if="routeName == 'Home'" src="/image/search.png" alt="search" class="search-icon" @click="handleSearch">
        </div>
    </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import moment from 'moment';
import 'moment/locale/zh-cn';
const router = useRouter();
const route = useRoute();
const routeName = computed(() => route.name);
/** 日期格式化 2025-09-23 周一 */
const dateTime = moment(new Date()).format('YYYY-MM-DD dddd');
moment.locale('zh-cn');


const handleClick = (item) => {
    if (item.linkType == '_blank') {
        return window.open( location.origin + item.url);
    }
    if (item.httpUrl) {
        return window.open(item.httpUrl);
    }
    router.push(item.url);
};
const lists = ref([
    {
        name: '首页',
        url: '/',
        routeName: 'Home'
    },
    {
        name: '720导视',
        httpUrl: 'https://www.qofo360.com/jinlin/bsfjq/index.html',
        routeName: '720Guide',
        tag: '热门'
    },
    {
        name: '历史遗存',
        url: '/culturalTour',
        routeName: 'culturalTour'
    },
    {
        name: '影音库',
        url: '/audiovisualLibrary',
        routeName: 'audiovisualLibrary'
    },
    {
        name: '祖地文旅',
        url: '/travelColumn',
        routeName: 'travelColumn'
    },
    {
        name: '大圣讲堂',
        url: '/literatureLecture',
        routeName: 'literatureLecture'
    },
    {
        name: '大圣文化',
        url: '/dsCulture',
        routeName: 'dsCulture'
    },
    {
        name: '电子图书平台',
        url: '/#/libHome',
        linkType: '_blank',
        tag: '免费阅读'
    }
]);

const handleSearch = () => {
    router.push('/articleSearch');
}
</script>
<style lang="scss" scoped>
.header-box{
    position: relative;
    height:175px;
    background:rgba(#272727, 0.3);
    z-index: 3;
    .search-icon {
            width:95px;
            height:41px;
            cursor: pointer;
            position: absolute;
            bottom: 25px;
            right: 20px;
        }
    .header-logo{
        padding: 22px 62px;
        border-bottom: 1px solid rgba(#fff, 0.3);
        display: flex;
        align-items: center;
        justify-content: space-between;

        span{
            font-weight:700;
            color:#ffffff;
            font-size:21px;
        }
        .logo{
            width: 284px;
        }

    }
}
.header-bg-white{
        background: #fff!important;
        .header-logo{
            border-bottom: 1px solid rgba(#dfdfdf, 0.3);
        }

        span{
            color:#4e4e4e ;
        }
        .mean-box{
            color:#4e4e4e;
            position: relative;

        }

    }
.mean-box{
    font-weight:700;
    color:#ffffff;
    font-size:21px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;

    > div{
        flex: 1;
        padding-top: 20px;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
        img{
            width: 58px;
            height: 19px;
            position: absolute;
            top: -15px;
            right: 12px;
        }
    }
    .tag{
                background: #b13a13;
                padding: 5px 10px;
                border-radius: 50px;
                color:#ffffff;
                font-size:14px;
                position: absolute;
                top: -10px;
                right: -10px;
            }
}
.mean-active{
    position: relative;
    &:after{
        content: '';
        position: absolute;
        bottom: -20px;
        left: 0;
        right: 0;
        width:70px;
        height:5px;
        background: #139db1;
        margin:auto;
    }
}
</style>
